module.exports = __webpack_public_path__ + "img/payment_mb_08.46fe6f0d.png";